import * as React from 'react';
import Svg, { G, Path, Defs, Mask, ClipPath, Use } from "react-native-svg"

/*
Letras para ID utilizadas:
a b c d e f g h k l m n o p
*/


function SvgCaja(props) {
  
  return (
      
    <Svg id="prefix__Capa_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 69 68"
      xmlSpace="preserve"
      enableBackground="new 0 0 69 68"
      {...props}
    >
      <style>
        {".prefix__stp1{fill-rule:evenodd;clip-rule:evenodd;fill:#364f6b}"}
      </style>
      <g id="prefix__Artboard-Copy-7">
        <g id="prefix__Page-1" transform="translate(-1 -2)">
          <path id="prefix__p1" fill="none" d="M-1 72h72V0H-1z" />
          <g id="prefix__Group-12">
            <path
              id="prefix__p2"
              className="prefix__stp1"
              d="M11.4 20.2H5.8c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2H8V27c0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2v-2.4c2.6-.5 4.5-2.8 4.5-5.5 0-3.1-2.5-5.6-5.6-5.6H9.1c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1h5.6c1.2 0 2.2-1 2.2-2.2s-1-2.2-2.2-2.2h-2.2V4.5c0-1.2-1-2.2-2.2-2.2C9 2.2 8 3.3 8 4.5v2.4c-2.6.5-4.5 2.8-4.5 5.5C3.5 15.5 6 18 9.1 18h2.2c.6 0 1.1.5 1.1 1.1s-.4 1.1-1 1.1"
            />
            <path
              id="prefix__p4"
              className="prefix__stp1"
              d="M48.5 54H14.8c-1.2 0-2.2-1-2.2-2.2V41.4l2.9 2.9c.9.9 2.3.9 3.2 0 .9-.9.9-2.3 0-3.2l-6.8-6.8c-.9-.9-2.3-.9-3.2 0l-6.8 6.8c-.9.9-.9 2.4 0 3.2.9.9 2.3.9 3.2 0L8 41.4v10.3c0 3.7 3 6.8 6.8 6.8h33.8c1.2 0 2.2-1 2.2-2.2S49.7 54 48.5 54"
            />
            <path
              id="prefix__p6"
              className="prefix__stp1"
              d="M58.6 51.8h5.6c1.2 0 2.2-1 2.2-2.2s-1-2.2-2.2-2.2H62V45c0-1.2-1-2.2-2.2-2.2-1.2 0-2.2 1-2.2 2.2v2.4c-2.6.5-4.5 2.8-4.5 5.5 0 3.1 2.5 5.6 5.6 5.6h2.2c.6 0 1.1.5 1.1 1.1s-.5 1.1-1.1 1.1h-5.6c-1.2 0-2.2 1-2.2 2.2 0 1.2 1 2.2 2.2 2.2h2.2v2.2c0 1.2 1 2.2 2.2 2.2 1.2 0 2.2-1 2.2-2.2v-2.4c2.6-.5 4.5-2.8 4.5-5.5 0-3.1-2.5-5.6-5.6-5.6h-2.2c-.6 0-1.1-.5-1.1-1.1s.5-.9 1.1-.9"
            />
            <path
              id="prefix__p8"
              className="prefix__stp1"
              d="M68.1 27.7c-.9-.9-2.3-.9-3.2 0L62 30.6V20.2c0-3.7-3-6.8-6.8-6.8H21.5c-1.2 0-2.2 1-2.2 2.2s1 2.2 2.2 2.2h33.8c1.2 0 2.2 1 2.2 2.2v10.3l-2.9-2.9c-.9-.9-2.3-.9-3.2 0-.9.9-.9 2.3 0 3.2l6.8 6.8c.9.9 2.3.9 3.2 0l6.8-6.8c.8-.6.8-2.1-.1-2.9"
            />
            <defs>
              <filter
                id="prefix__Adobe_OpacityMaskFilter"
                filterUnits="userSpaceOnUse"
                x={21.5}
                y={22.5}
                width={27}
                height={27}
              >
                <feColorMatrix values="1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0" />
              </filter>
            </defs>
            <mask
              maskUnits="userSpaceOnUse"
              x={21.5}
              y={22.5}
              width={27}
              height={27}
              id="prefix__pmask-2_2_"
            >
              <g filter="url(#prefix__Adobe_OpacityMaskFilter)">
                <path
                  id="prefix__ppath-1_2_"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#fff"
                  d="M-1 72h72V0H-1z"
                />
              </g>
            </mask>
            <path
              id="prefix__p10"
              mask="url(#prefix__mask-2_2_)"
              fillRule="evenodd"
              clipRule="evenodd"
              fill="#1bb5ec"
              d="M21.5 49.5h27v-27h-27z"
            />
          </g>
        </g>
      </g>
    </Svg>
    
  );
}


function SvgCalendarioAzul(props) {
  
  return (
    
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" {...props} >
      <defs>
        <path
          id="k1"
          d="M17.5 1.9h-1.2v-.6c0-.3-.3-.6-.6-.6h-2.5c-.3 0-.6.3-.6.6v.6h-5v-.6c0-.3-.3-.6-.6-.6H4.4c-.3 0-.6.3-.6.6v.6H2.5c-1 0-1.9.8-1.9 1.9v13.8c0 1 .8 1.9 1.9 1.9h15c1 0 1.9-.8 1.9-1.9V3.8c0-1.1-.8-1.9-1.9-1.9zm-3.7 1.2H15V1.9h-1.2v1.2zM5 3.1h1.2V1.9H5v1.2zm-3.1.7c0-.3.3-.6.6-.6h1.2v.6c0 .3.3.6.6.6h2.5c.3 0 .6-.3.6-.6v-.7h5v.6c0 .3.3.6.6.6h2.5c.3 0 .6-.3.6-.6v-.6h1.2c.3 0 .6.3.6.6v1.9h-16V3.8zm16.2 13.7c0 .3-.3.6-.6.6h-15c-.3 0-.6-.3-.6-.6V6.9h16.2v10.6z"
        />
      </defs>
      <clipPath id="k2">
        <use xlinkHref="#k1" overflow="visible" />
      </clipPath>
      <g clipPath="url(#k2)">
        <defs>
          <path id="k3" d="M0 0h20v20H0z" />
        </defs>
        <clipPath id="k4">
          <use xlinkHref="#k3" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#k4)"
          fill="#005d8f"
          d="M-4.4-4.4h28.8v28.8H-4.4z"
        />
      </g>
      <g>
        <defs>
          <path
            id="k5"
            d="M6.9 13.1h2.5v2.5c0 .3.3.6.6.6s.6-.3.6-.6v-2.5h2.5c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-2.5V9.4c0-.3-.3-.6-.6-.6s-.6.3-.6.6v2.5H6.9c-.3 0-.6.3-.6.6s.3.6.6.6"
          />
        </defs>
        <clipPath id="k6">
          <use xlinkHref="#k5" overflow="visible" />
        </clipPath>
        <g clipPath="url(#k6)">
          <defs>
            <path id="k7" d="M0 0h20v20H0z" />
          </defs>
          <clipPath id="k8">
            <use xlinkHref="#k7" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#k8)"
            fill="#005d8f"
            d="M1.3 3.8h17.5v17.5H1.3z"
          />
        </g>
      </g>
    </Svg>
    
  );
}


function SvgCalendarioBlanco(props) {
  
  return (
    
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" {...props} >
      <defs>
        <path
          id="m1"
          d="M17.5 1.9h-1.2v-.7c0-.3-.3-.6-.6-.6h-2.5c-.3 0-.6.3-.6.6v.6h-5v-.6c0-.3-.3-.6-.6-.6H4.4c-.4 0-.6.3-.6.6v.6H2.5c-1 0-1.9.8-1.9 1.9v13.8c0 1 .8 1.9 1.9 1.9h15c1 0 1.9-.8 1.9-1.9V3.8c0-1.1-.9-1.9-1.9-1.9zm-3.7 1.2H15V1.9h-1.2v1.2zM5 3.1h1.2V1.9H5v1.2zm-3.1.7c0-.3.3-.6.6-.6h1.2v.6c0 .3.3.6.6.6h2.5c.3 0 .6-.3.6-.6v-.7h5v.6c0 .3.3.6.6.6h2.5c.3 0 .6-.3.6-.6v-.6h1.2c.3 0 .6.3.6.6v1.9h-16V3.8zm16.2 13.7c0 .3-.3.6-.6.6h-15c-.3 0-.6-.3-.6-.6V6.9h16.2v10.6z"
        />
      </defs>
      <clipPath id="m2">
        <use xlinkHref="#m1" overflow="visible" />
      </clipPath>
      <g clipPath="url(#m2)">
        <defs>
          <path id="m3" d="M0 0h20v20H0z" />
        </defs>
        <clipPath id="m4">
          <use xlinkHref="#m3" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#m4)"
          fill="#fff"
          d="M-4.4-4.4h28.8v28.8H-4.4z"
        />
      </g>
      <g>
        <defs>
          <path
            id="m5"
            d="M6.9 13.1h2.5v2.5c0 .3.3.6.6.6s.6-.3.6-.6v-2.5h2.5c.3 0 .6-.3.6-.6s-.3-.6-.6-.6h-2.5V9.4c0-.3-.3-.6-.6-.6s-.6.2-.6.6v2.5H6.9c-.3 0-.6.3-.6.6s.2.6.6.6"
          />
        </defs>
        <clipPath id="m6">
          <use xlinkHref="#m5" overflow="visible" />
        </clipPath>
        <g clipPath="url(#m6)">
          <defs>
            <path id="m7" d="M0 0h20v20H0z" />
          </defs>
          <clipPath id="m8">
            <use xlinkHref="#m7" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#m8)"
            fill="#fff"
            d="M1.2 3.8h17.5v17.5H1.2z"
          />
        </g>
      </g>
    </Svg>
    
  );
}


function SvgDia(props) {
  
  return (
    
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 20 20" {...props} >
    <defs>
      <path
        id="l1"
        d="M17.5 1.8h-1.2v-.6c0-.3-.3-.6-.6-.6h-2.5c-.3 0-.6.3-.6.6v.6h-5v-.6c0-.3-.3-.6-.6-.6H4.4c-.4-.1-.6.2-.6.6v.6H2.5c-1 0-1.9.8-1.9 1.9v13.8c0 1 .8 1.9 1.9 1.9h15c1 0 1.9-.8 1.9-1.9V3.7c0-1.1-.9-1.9-1.9-1.9zM13.8 3H15V1.8h-1.2V3zM5 3h1.2V1.8H5V3zm-3.1.7c0-.4.3-.7.6-.7h1.2v.6c.1.4.3.7.7.7h2.5c.3 0 .6-.3.6-.6V3h5v.6c0 .3.3.6.6.6h2.5c.3 0 .6-.3.6-.6V3h1.2c.3 0 .6.3.6.6v1.9H1.9V3.7zm16.2 13.7c0 .3-.3.6-.6.6h-15c-.3 0-.6-.3-.6-.6V6.8h16.2v10.6z"
      />
    </defs>
    <clipPath id="l2">
      <use xlinkHref="#l1" overflow="visible" />
    </clipPath>
    <g clipPath="url(#l2)">
      <defs>
        <path id="l3" d="M0-.1h20v20H0z" />
      </defs>
      <clipPath id="l4">
        <use xlinkHref="#l3" overflow="visible" />
      </clipPath>
      <path
        clipPath="url(#l4)"
        fill="#007db7"
        d="M-4.4-4.5h28.8v28.8H-4.4z"
      />
    </g>
    </Svg>
    
  );
}


function SvgDistancia(props) {
  
  return (
      
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" {...props} >
      <defs>
        <path
          id="prefix__a"
          d="M3.4 8.4c.1-.1 2.1-2.2 2.1-5.3C5.5 1.7 4.4.5 3 .5S.5 1.7.5 3.1c0 3.1 2.1 5.2 2.1 5.3.2.1.6.1.8 0M3 1.5c.8 0 1.5.7 1.5 1.6 0 1.9-1 3.4-1.5 4.1-.5-.7-1.5-2.2-1.5-4.1 0-.9.7-1.6 1.5-1.6"
        />
      </defs>
      <clipPath id="prefix__b">
        <use xlinkHref="#prefix__a" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__b)">
        <defs>
          <path id="prefix__c" d="M0 0h16v16H0z" />
        </defs>
        <clipPath id="prefix__d">
          <use xlinkHref="#prefix__c" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#prefix__d)"
          fill="#007db7"
          d="M-4.5-4.5h15v18h-15z"
        />
      </g>
      <defs>
        <path
          id="prefix__e"
          d="M3.5 3c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5"
        />
      </defs>
      <clipPath id="prefix__f">
        <use xlinkHref="#prefix__e" overflow="visible" />
      </clipPath>
      <g clipPath="url(#prefix__f)">
        <defs>
          <path id="prefix__g" d="M0 0h16v16H0z" />
        </defs>
        <clipPath id="prefix__h">
          <use xlinkHref="#prefix__g" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#prefix__h)"
          fill="#007db7"
          d="M-2.5-2.5h11v11h-11z"
        />
      </g>
      <g>
        <defs>
          <path
            id="prefix__i"
            d="M15.5 6.1c0-1.4-1.1-2.6-2.5-2.6s-2.5 1.2-2.5 2.6c0 3.1 2.1 5.2 2.1 5.3 1 .9 2.9-3 2.9-5.3M13 4.5c.8 0 1.5.7 1.5 1.6 0 1.9-1 3.4-1.5 4.1-.5-.7-1.5-2.2-1.5-4.1 0-.9.7-1.6 1.5-1.6"
          />
        </defs>
        <clipPath id="prefix__j">
          <use xlinkHref="#prefix__i" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__j)">
          <defs>
            <path id="prefix__k" d="M0 0h16v16H0z" />
          </defs>
          <clipPath id="prefix__l">
            <use xlinkHref="#prefix__k" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#prefix__l)"
            fill="#007db7"
            d="M5.5-1.5h15v18h-15z"
          />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="prefix__m"
            d="M13.5 6c0-.3-.2-.5-.5-.5s-.5.2-.5.5.2.5.5.5.5-.2.5-.5"
          />
        </defs>
        <clipPath id="prefix__n">
          <use xlinkHref="#prefix__m" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__n)">
          <defs>
            <path id="prefix__o" d="M0 0h16v16H0z" />
          </defs>
          <clipPath id="prefix__p">
            <use xlinkHref="#prefix__o" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#prefix__p)"
            fill="#007db7"
            d="M7.5.5h11v11h-11z"
          />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="prefix__q"
            d="M13 12.5c-.6 0-1.1.3-1.3.8l-7.2-2.7C4.3 10 3.7 9.5 3 9.5c-.8 0-1.5.7-1.5 1.5s.7 1.5 1.5 1.5c.6 0 1.1-.3 1.3-.8l7.2 2.7c.2.7.7 1.1 1.4 1.1.8 0 1.5-.7 1.5-1.5s-.6-1.5-1.4-1.5m-10-1c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5m10 3c-.3 0-.5-.2-.5-.5s.2-.5.5-.5.5.2.5.5-.2.5-.5.5"
          />
        </defs>
        <clipPath id="prefix__r">
          <use xlinkHref="#prefix__q" overflow="visible" />
        </clipPath>
        <g clipPath="url(#prefix__r)">
          <defs>
            <path id="prefix__s" d="M0 0h16v16H0z" />
          </defs>
          <clipPath id="prefix__t">
            <use xlinkHref="#prefix__s" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#prefix__t)"
            fill="#007db7"
            d="M-3.5 4.5h23v16h-23z"
          />
        </g>
      </g>
    </Svg>
    
  );
}
  
 
function SvgFila(props) {
  
  return (
      
    <Svg id="f_1" xmlns="http://www.w3.org/2000/svg" x={0} y={0} viewBox="0 0 32 29" xmlSpace="preserve" {...props} >
      <style>
        {
          ".prefix__f1,.prefix__f2{fill-rule:evenodd;clip-rule:evenodd;fill:#1bb5ec}.prefix__f2{fill:#364f6b}"
        }
      </style>
      <g id="f__Artboard-Copy-21">
        <g id="f__Group">
          <g id="f-1">
            <path id="f1" fill="none" d="M0 33h32V0H0z" />
            <g id="prefix__Group-20" transform="translate(1 1.03)">
              <path
                id="f2"
                className="prefix__f1"
                d="M25 11.3c-3 0-5 2.8-5 5.8v1.4c0 .6.4 1 1 1h8c.6 0 1-.5 1-1v-1.4c0-3-2-5.8-5-5.8"
              />
              <path
                id="f4"
                className="prefix__f1"
                d="M10 18.5v-1.4c0-3-2-5.8-5-5.8s-5 2.8-5 5.8v1.4c0 .6.4 1 1 1h8c.6.1 1-.4 1-1"
              />
              <path
                id="f6"
                className="prefix__f1"
                d="M15 17.5c-3.4 0-6 3-6 6.4v1.8c0 .6.4 1 1 1h10c.6 0 1-.5 1-1v-1.8c0-3.5-2.7-6.4-6-6.4"
              />
              <path
                id="f8"
                className="prefix__f2"
                d="M28 17.5h-6v-.4c0-1.8 1.1-3.7 3-3.7s3 1.9 3 3.7v.4zm-3-6.2c-3 0-5 2.8-5 5.8v1.4c0 .6.4 1 1 1h8c.6 0 1-.5 1-1v-1.4c0-3-2-5.8-5-5.8z"
              />
              <path
                id="f10"
                className="prefix__f2"
                d="M23 3.1c0-.6.4-1 1-1h2c.6 0 1 .5 1 1v4.1c0 .6-.4 1-1 1h-2c-.6 0-1-.5-1-1V3.1zm1 7.2h2c1.7 0 3-1.4 3-3.1V3.1C29 1.4 27.7 0 26 0h-2c-1.7 0-3 1.4-3 3.1v4.1c0 1.7 1.3 3.1 3 3.1z"
              />
              <path
                id="f12"
                className="prefix__f2"
                d="M8 17.5H2v-.4c0-1.8 1.1-3.7 3-3.7s3 1.9 3 3.7v.4zm2 1v-1.4c0-3-2-5.8-5-5.8s-5 2.8-5 5.8v1.4c0 .6.4 1 1 1h8c.6.1 1-.4 1-1z"
              />
              <path
                id="f14"
                className="prefix__f2"
                d="M3 3.1c0-.6.4-1 1-1h2c.6 0 1 .5 1 1v4.1c0 .6-.4 1-1 1H4c-.6 0-1-.5-1-1V3.1zm1 7.2h2c1.7 0 3-1.4 3-3.1V3.1C9 1.4 7.7 0 6 0H4C2.3 0 1 1.4 1 3.1v4.1c0 1.7 1.3 3.1 3 3.1z"
              />
              <path
                id="f16"
                className="prefix__f2"
                d="M19 24.7h-8v-.8c0-2.3 1.7-4.4 4-4.4s4 2 4 4.4v.8zm-4-7.2c-3.4 0-6 3-6 6.4v1.8c0 .6.4 1 1 1h10c.6 0 1-.5 1-1v-1.8c0-3.5-2.7-6.4-6-6.4z"
              />
              <path
                id="f18"
                className="prefix__f2"
                d="M12 6.2c0-1.1.9-2.1 2-2.1h2c1.1 0 2 .9 2 2.1v5.2c0 1.1-.9 2.1-2 2.1h-2c-1.1 0-2-.9-2-2.1V6.2zm2 9.3h2c2.2 0 4-1.8 4-4.1V6.2c0-2.3-1.8-4.1-4-4.1h-2c-2.2 0-4 1.8-4 4.1v5.2c0 2.2 1.8 4.1 4 4.1z"
              />
            </g>
          </g>
        </g>
      </g>
    </Svg>
    
  );
}

 
function SvgHora(props) {
  
  return (
      
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 15 20" {...props} >
      <defs>
        <path
          id="g1"
          d="M10.7 4.2l-.8-3.1c0-.3-.3-.5-.6-.5H4.6c-.3 0-.5.2-.6.5l-.8 3.1C1.4 5.5.1 7.6.1 10s1.3 4.5 3.1 5.8l.8 3.1c.1.3.3.5.6.5h4.7c.3 0 .5-.2.6-.5l.8-3.1c1.9-1.2 3.1-3.4 3.1-5.8s-1.2-4.5-3.1-5.8zM5.1 1.9h3.7l.4 1.6c-.7-.2-1.4-.4-2.2-.4s-1.6.2-2.3.4l.4-1.6zm3.7 16.2H5.1l-.4-1.6c.7.2 1.5.4 2.3.4s1.6-.1 2.3-.4l-.5 1.6zM7 15.6c-3.1 0-5.6-2.5-5.6-5.6 0-3.1 2.5-5.6 5.6-5.6s5.6 2.5 5.6 5.6c0 3.1-2.5 5.6-5.6 5.6z"
        />
      </defs>
      <clipPath id="g2">
        <use xlinkHref="#g1" overflow="visible" />
      </clipPath>
      <g clipPath="url(#g2)">
        <defs>
          <path id="g3" d="M0 0h15v20H0z" />
        </defs>
        <clipPath id="g4">
          <use xlinkHref="#g3" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#g4)"
          fill="#007db7"
          d="M-4.9-4.4h23.8v28.8H-4.9z"
        />
      </g>
      <g>
        <defs>
          <path
            id="g5"
            d="M8.2 9.4h-.6V7.5c0-.3-.3-.6-.6-.6s-.6.3-.6.6V10c0 .3.3.6.6.6h1.2c.3 0 .6-.3.6-.6s-.2-.6-.6-.6"
          />
        </defs>
        <clipPath id="g6">
          <use xlinkHref="#g5" overflow="visible" />
        </clipPath>
        <g clipPath="url(#g6)">
          <defs>
            <path id="g7" d="M0 0h15v20H0z" />
          </defs>
          <clipPath id="g8">
            <use xlinkHref="#g7" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#g8)"
            fill="#007db7"
            d="M1.3 1.9h12.5v13.8H1.3z"
          />
        </g>
      </g>
    </Svg>
    
  );
}

 
function SvgLista(props) {
  
  return (
      
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 28 32" {...props} >
      <defs>
        <path
          id="o1"
          d="M4.4 29.1c-1.4 0-2.6-1.2-2.6-2.6 0-1.4 1.2-2.6 2.6-2.6S7 25 7 26.5c0 1.4-1.2 2.6-2.6 2.6m0-3.5c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9c-.1-.5-.4-.9-.9-.9"
        />
      </defs>
      <clipPath id="o2">
        <use xlinkHref="#o1" overflow="visible" />
      </clipPath>
      <g clipPath="url(#o2)">
        <defs>
          <path id="o3" d="M0 0h28v32H0z" />
        </defs>
        <clipPath id="o4">
          <use xlinkHref="#o3" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#o4)"
          fill="#f42534"
          d="M-3.2 18.9H12v15.2H-3.2z"
        />
      </g>
      <defs>
        <path
          id="o5"
          d="M4.4 18.6c-1.4 0-2.6-1.2-2.6-2.6s1.2-2.6 2.6-2.6S7 14.5 7 16s-1.2 2.6-2.6 2.6m0-3.5c-.5 0-.9.4-.9.9s.4.9.9.9.9-.4.9-.9c-.1-.5-.4-.9-.9-.9"
        />
      </defs>
      <clipPath id="o6">
        <use xlinkHref="#o5" overflow="visible" />
      </clipPath>
      <g clipPath="url(#o6)">
        <defs>
          <path id="o7" d="M0 0h28v32H0z" />
        </defs>
        <clipPath id="o8">
          <use xlinkHref="#o7" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#o8)"
          fill="#f42534"
          d="M-3.2 8.4H12v15.2H-3.2z"
        />
      </g>
      <g>
        <defs>
          <path
            id="o9"
            d="M4.4 8.1C3 8.1 1.8 6.9 1.8 5.5S3 2.9 4.4 2.9 7 4 7 5.5 5.8 8.1 4.4 8.1m0-3.5c-.5 0-.9.4-.9.9s.4.9.9.9.8-.4.8-.9-.3-.9-.8-.9"
          />
        </defs>
        <clipPath id="o10">
          <use xlinkHref="#o9" overflow="visible" />
        </clipPath>
        <g clipPath="url(#o10)">
          <defs>
            <path id="o11" d="M0 0h28v32H0z" />
          </defs>
          <clipPath id="o12">
            <use xlinkHref="#o11" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#o12)"
            fill="#f42534"
            d="M-3.2-2.2H12V13H-3.2z"
          />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="o13"
            d="M25.4 27.4h-14c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h14c.5 0 .9.4.9.9s-.4.9-.9.9"
          />
        </defs>
        <clipPath id="o14">
          <use xlinkHref="#o13" overflow="visible" />
        </clipPath>
        <g clipPath="url(#o14)">
          <defs>
            <path id="o15" d="M0 0h28v32H0z" />
          </defs>
          <clipPath id="o16">
            <use xlinkHref="#o15" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#o16)"
            fill="#f42534"
            d="M5.5 20.6h25.8v11.8H5.5z"
          />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="o17"
            d="M25.4 16.9h-14c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h14c.5 0 .9.4.9.9s-.4.9-.9.9"
          />
        </defs>
        <clipPath id="o18">
          <use xlinkHref="#o17" overflow="visible" />
        </clipPath>
        <g clipPath="url(#o18)">
          <defs>
            <path id="o19" d="M0 0h28v32H0z" />
          </defs>
          <clipPath id="o20">
            <use xlinkHref="#o19" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#o20)"
            fill="#f42534"
            d="M5.5 10.1h25.8v11.8H5.5z"
          />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="o21"
            d="M25.4 6.3h-14c-.5 0-.9-.4-.9-.9s.4-.9.9-.9h14c.5 0 .9.4.9.9s-.4.9-.9.9"
          />
        </defs>
        <clipPath id="o22">
          <use xlinkHref="#o21" overflow="visible" />
        </clipPath>
        <g clipPath="url(#o22)">
          <defs>
            <path id="o23" d="M0 0h28v32H0z" />
          </defs>
          <clipPath id="o24">
            <use xlinkHref="#o23" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#o24)"
            fill="#f42534"
            d="M5.5-.4h25.8v11.8H5.5z"
          />
        </g>
      </g>
    </Svg>
    
  );
}

 
function SvgLogoCoopeuch(props) {
  
  return (
      
    <Svg xmlns="http://www.w3.org/2000/svg" width={434} height={75} viewBox="0 0 434 75" {...props} >
      <title>{"Group-2"}</title>
      <g fill="#FFF" fillRule="nonzero">
        <path d="M72.492 33.001c-21.427.799-38.713 18.506-39.49 40.454-.032.843.628 1.545 1.453 1.545h30.853C70.11 75 74 71.015 74 66.097V34.493c0-.845-.683-1.522-1.508-1.492" />
        <path d="M66.28 0H27.796C12.445 0 0 12.445 0 27.796V66.28A8.72 8.72 0 008.72 75h5.2a1.43 1.43 0 001.431-1.423c.749-31.776 26.461-57.484 58.237-58.226A1.43 1.43 0 0075 13.921v-5.2A8.72 8.72 0 0066.28 0M113.711 46.547c-2.924 0-5.321-.96-7.195-2.806-1.873-1.922-2.847-4.358-2.847-7.24 0-5.908 4.271-10.119 10.042-10.119 3.205 0 5.989 1.35 7.688 3.57.56.735 1.57.966 2.375.503l5.238-3.022a1.768 1.768 0 00.576-2.539C126.244 20.013 120.35 17 113.786 17c-5.62 0-10.343 1.848-14.166 5.614C95.873 26.382 94 30.961 94 36.501c0 5.538 1.873 10.12 5.62 13.887 3.823 3.766 8.546 5.612 14.166 5.612 6.558 0 12.38-3.062 15.881-7.946a1.766 1.766 0 00-.574-2.574l-5.254-2.957c-.8-.452-1.796-.219-2.354.505-1.7 2.214-4.497 3.519-7.774 3.519M281.914 17c-5.809 0-10.637 1.846-14.333 5.614C263.885 26.306 262 30.961 262 36.5c0 5.614 1.885 10.268 5.656 13.96C271.43 54.154 276.408 56 282.67 56c6.698 0 11.91-2.276 15.581-6.765a1.213 1.213 0 00-.354-1.826l-5.265-2.976c-.733-.414-1.672-.33-2.28.25-1.848 1.768-4.389 2.674-7.532 2.674-5.809 0-9.354-2.289-10.637-6.943h24.854c2.188 0 3.962-1.735 3.964-3.877v-.038c0-5.538-1.81-10.12-5.431-13.885-3.546-3.768-8.147-5.614-13.655-5.614zm-9.882 16.027c1.133-4.725 4.678-7.46 9.882-7.46 4.453 0 8.224 2.438 9.356 7.46h-19.238zM338.49 36.51c0 2.954-.959 5.39-2.875 7.308-1.916 1.919-4.277 2.878-7.152 2.878-2.874 0-5.235-.96-7.152-2.878-1.842-1.919-2.8-4.354-2.8-7.309V18.541A1.54 1.54 0 00316.97 17h-6.197c-.982 0-1.774.796-1.774 1.776v17.733c0 5.464 1.843 10.113 5.602 13.88 3.761 3.764 8.405 5.611 13.861 5.611 5.457 0 10.1-1.847 13.862-5.611 3.759-3.767 5.675-8.416 5.675-13.88V18.776c0-.98-.795-1.776-1.774-1.776h-5.963c-.979 0-1.773.796-1.773 1.776v17.733zM424.653 18.61v12.599a47.386 47.386 0 01-17.306-.132V18.61c0-.89-.769-1.61-1.718-1.61h-5.911c-.95 0-1.718.72-1.718 1.61v32.78c0 .89.769 1.61 1.718 1.61h5.911c.95 0 1.718-.72 1.718-1.61v-11.3c2.965.476 5.975.743 9.01.743 2.788 0 5.557-.226 8.296-.629V51.39c0 .89.769 1.61 1.718 1.61h5.911c.95 0 1.718-.72 1.718-1.61V18.61c0-.89-.769-1.61-1.718-1.61h-5.911c-.95 0-1.718.72-1.718 1.61M259.529 26.85C258.362 21.213 253.29 17 246.98 17h-18.384c-.882 0-1.597.706-1.597 1.574v32.852c0 .87.715 1.574 1.597 1.574h5.882c.884 0 1.6-.704 1.6-1.574v-7.862h9.797c6.1 0 11.67-3.766 13.52-9.489.83-2.573.736-5.002.133-7.225m-14.664 8.843h-8.994V24.505h8.994c3.138 0 5.684 2.503 5.684 5.594 0 3.09-2.546 5.594-5.684 5.594M154.464 17c-5.457 0-10.1 1.922-13.861 5.688-3.76 3.765-5.603 8.346-5.603 13.81 0 5.468 1.843 10.122 5.603 13.888 3.76 3.768 8.404 5.614 13.86 5.614 5.456 0 10.101-1.846 13.86-5.614 3.761-3.766 5.677-8.42 5.677-13.887 0-5.465-1.916-10.046-5.677-13.811-3.759-3.766-8.404-5.688-13.86-5.688m7.152 26.812c-1.916 1.922-4.277 2.88-7.151 2.88-2.876 0-5.235-.958-7.15-2.88-1.846-1.92-2.804-4.358-2.804-7.313 0-2.953.958-5.391 2.803-7.311 1.916-1.92 4.275-2.882 7.15-2.882s5.236.962 7.152 2.882c1.916 1.92 2.876 4.358 2.876 7.31 0 2.956-.96 5.394-2.876 7.314M199.463 17c-5.455 0-10.1 1.922-13.861 5.688-3.76 3.765-5.602 8.346-5.602 13.81 0 5.468 1.843 10.122 5.602 13.888 3.76 3.768 8.406 5.614 13.861 5.614s10.101-1.846 13.86-5.614c3.76-3.766 5.677-8.42 5.677-13.887 0-5.465-1.916-10.046-5.677-13.811-3.759-3.766-8.405-5.688-13.86-5.688m7.151 26.812c-1.916 1.922-4.277 2.88-7.15 2.88-2.877 0-5.236-.958-7.152-2.88-1.842-1.92-2.803-4.358-2.803-7.313 0-2.953.96-5.391 2.803-7.311 1.916-1.92 4.275-2.882 7.151-2.882 2.874 0 5.235.962 7.151 2.882 1.916 1.92 2.877 4.358 2.877 7.31 0 2.956-.96 5.394-2.877 7.314M373.711 46.546c-2.924 0-5.321-.96-7.195-2.808-1.873-1.92-2.847-4.358-2.847-7.238 0-5.908 4.271-10.12 10.042-10.12 3.205 0 5.989 1.35 7.688 3.57.56.735 1.57.967 2.375.504l5.238-3.023a1.769 1.769 0 00.576-2.538C386.244 20.01 380.35 17 373.786 17c-5.622 0-10.343 1.846-14.166 5.612C355.873 26.38 354 30.96 354 36.5c0 5.539 1.873 10.12 5.62 13.888 3.823 3.766 8.544 5.612 14.166 5.612 6.555 0 12.38-3.062 15.881-7.944a1.768 1.768 0 00-.574-2.577l-5.254-2.96c-.8-.45-1.796-.218-2.354.508-1.7 2.214-4.497 3.52-7.774 3.52" />
      </g>
    </Svg>
    
  );
}

 
function SvgLogoCoopeuchMobile(props) {
  
  return (
      
    <Svg xmlns="http://www.w3.org/2000/svg" width={75} height={75} viewBox="0 0 75 75" {...props} >
    <title>{"Group-1"}</title>
    <g fill="#FFF" fillRule="nonzero">
      <path d="M72.492 33.001c-21.427.799-38.713 18.506-39.49 40.454-.032.843.628 1.545 1.453 1.545h30.853C70.11 75 74 71.015 74 66.097V34.493c0-.845-.683-1.522-1.508-1.492" />
      <path d="M66.28 0H27.796C12.445 0 0 12.445 0 27.796V66.28A8.72 8.72 0 008.72 75h5.2a1.43 1.43 0 001.431-1.423c.749-31.776 26.461-57.484 58.237-58.226A1.43 1.43 0 0075 13.921v-5.2A8.72 8.72 0 0066.28 0M113.711 46.547c-2.924" />
    </g>
    </Svg>
    
  );
}


function SvgMapaBlue(props) {
  
  return (
    
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" {...props} >
      <defs>
        <path
          id="e1"
          d="M15.5 14.4l-2-8c-.1-.3-.3-.4-.6-.4-.3.1-.4.3-.4.6l.6 2.5-2.6 1.8L4.7 7H9c.3 0 .5-.2.5-.5S9.3 6 9 6H3c-.2 0-.4.1-.5.4l-2 8c-.1.3.2.6.5.6h14c.3 0 .6-.3.5-.6zM1.6 14l1.7-6.7 10 6.7H1.6zm9.8-2.5l2-1.3.8 3.2-2.8-1.9z"
        />
      </defs>
      <clipPath id="e2">
        <use xlinkHref="#e1" overflow="visible" />
      </clipPath>
      <g clipPath="url(#e2)">
        <defs>
          <path id="e3" d="M0 0h16v16H0z" />
        </defs>
        <clipPath id="e4">
          <use xlinkHref="#e3" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#e4)"
          fill="#007db7"
          d="M-4.5 1h25v19h-25z"
        />
      </g>
      <g>
        <defs>
          <path
            id="e5"
            d="M10.5 4.9v2.6c0 .3.2.5.5.5s.5-.2.5-.5V4.9c.9-.2 1.5-1 1.5-1.9 0-1.1-.9-2-2-2s-2 .9-2 2c0 .9.6 1.7 1.5 1.9M11 2c.6 0 1 .4 1 1s-.4 1-1 1-1-.4-1-1 .4-1 1-1"
          />
        </defs>
        <clipPath id="e6">
          <use xlinkHref="#e5" overflow="visible" />
        </clipPath>
        <g clipPath="url(#e6)">
          <defs>
            <path id="e7" d="M0 0h16v16H0z" />
          </defs>
          <clipPath id="e8">
            <use xlinkHref="#e7" overflow="visible" />
          </clipPath>
          <path clipPath="url(#e8)" fill="#007db7" d="M4-4h14v17H4z" />
        </g>
      </g>
    </Svg>
    
  );
}

 
function SvgMapaRojo(props) {
  
  return (
    
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 28 28" {...props} >
      <path fill="none" d="M0 28h28V0H0z" />
      <defs>
        <path
          id="d1"
          d="M27.1 25.2l-3.5-14a.8.8 0 00-1.1-.6c-.5.1-.8.6-.6 1.1L23 16l-4.6 3.1-10.3-6.9h7.6c.5 0 .9-.4.9-.9s-.4-.9-.9-.9H5.3c-.4 0-.7.3-.8.7L1 25.1c-.1.6.3 1.1.8 1.1h24.5c.6 0 .9-.5.8-1zm-24.2-.7l2.9-11.7 17.6 11.7H2.9zM20 20.1l3.5-2.3 1.4 5.6-4.9-3.3z"
        />
      </defs>
      <clipPath id="d2">
        <use xlinkHref="#d1" overflow="visible" />
      </clipPath>
      <g clipPath="url(#d2)">
        <defs>
          <path id="d3" d="M0 0h28v28H0z" />
        </defs>
        <clipPath id="d4">
          <use xlinkHref="#d3" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#d4)"
          fill="#f42534"
          d="M-4.1 5.5h36.2v25.8H-4.1z"
        />
      </g>
      <g>
        <defs>
          <path
            id="d5"
            d="M18.4 8.6v4.5c0 .5.4.9.9.9s.9-.4.9-.9V8.6c1.5-.4 2.6-1.8 2.6-3.4 0-1.9-1.6-3.5-3.5-3.5s-3.5 1.6-3.5 3.5c0 1.7 1.1 3 2.6 3.4m.9-5.1c1 0 1.8.8 1.8 1.8S20.2 7 19.3 7s-1.8-.8-1.8-1.8.8-1.7 1.8-1.7"
          />
        </defs>
        <clipPath id="d6">
          <use xlinkHref="#d5" overflow="visible" />
        </clipPath>
        <g clipPath="url(#d6)">
          <defs>
            <path id="d7" d="M0 0h28v28H0z" />
          </defs>
          <clipPath id="d8">
            <use xlinkHref="#d7" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#d8)"
            fill="#f42534"
            d="M10.8-3.2h17V19h-17z"
          />
        </g>
      </g>
    </Svg>
    
  );
}


function SvgPersonas(props) {
  
  return (
      
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 70 72" {...props}>
    <g fillRule="evenodd" clipRule="evenodd">
      <path
        d="M67.7 72H2.3C1 72 0 71 0 69.7c0-19.3 15.7-35 35-35s35 15.7 35 35c0 1.3-1 2.3-2.3 2.3"
        fill="#1bb5ec"
      />
      <path
        d="M4.8 67.3c1.2-15.6 14.3-28 30.2-28s29 12.4 30.2 28H4.8zM21 20.7c0-7.7 6.3-14 14-14s14 6.3 14 14-6.3 14-14 14-14-6.3-14-14zm24.3 15.5c5-3.3 8.4-9.1 8.4-15.6C53.7 10.4 45.3 2 35 2s-18.7 8.4-18.7 18.7c0 6.5 3.3 12.2 8.4 15.6C10.4 40.6 0 54 0 69.7 0 71 1 72 2.3 72h65.3c1.3 0 2.3-1 2.3-2.3C70 54 59.6 40.6 45.3 36.2z"
        fill="#364f6b"
      />
    </g>
    </Svg>
    
  );
}


function SvgReloj(props) {
  
  return (
      
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 16 16" {...props} >
      <defs>
        <path
          id="b1"
          d="M13.3 2.7C10.4-.2 5.6-.2 2.7 2.7c-2.9 2.9-2.9 7.7 0 10.6 2.9 2.9 7.7 2.9 10.6 0 2.9-2.9 2.9-7.7 0-10.6m-.7 9.9c-2.5 2.5-6.6 2.5-9.2 0-2.5-2.5-2.5-6.7 0-9.2C5.9.9 10 .9 12.6 3.4c2.5 2.5 2.5 6.7 0 9.2"
        />
      </defs>
      <clipPath id="b2">
        <use xlinkHref="#b1" overflow="visible" />
      </clipPath>
      <g clipPath="url(#b2)">
        <defs>
          <path id="b3" d="M0 0h16v16H0z" />
        </defs>
        <clipPath id="b4">
          <use xlinkHref="#b3" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#b4)"
          fill="#007db7"
          d="M-4.5-4.5h25v25h-25z"
        />
      </g>
      <g>
        <defs>
          <path
            id="b5"
            d="M8.5 7.8V3c0-.3-.2-.5-.5-.5s-.5.2-.5.5v5c0 .1.1.3.1.4l2 2c.2.2.5.2.7 0 .2-.2.2-.5 0-.7L8.5 7.8z"
          />
        </defs>
        <clipPath id="b6">
          <use xlinkHref="#b5" overflow="visible" />
        </clipPath>
        <g clipPath="url(#b6)">
          <defs>
            <path id="b7" d="M0 0h16v16H0z" />
          </defs>
          <clipPath id="b8">
            <use xlinkHref="#b7" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#b8)"
            fill="#007db7"
            d="M2.5-2.5h13v18h-13z"
          />
        </g>
      </g>
    </Svg>
    
  );
}

 
function SvgRelojArena(props) {
  
  return (
      
    <Svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path fill="none" d="M0 33h32V0H0z" />
      <g fillRule="evenodd" clipRule="evenodd">
        <path
          d="M6.4 23.73c-.9 2-1.4 4.3-1.4 6.6v.6c0 .6.4 1 1 1h20c.6 0 1-.5 1-1v-.6c0-2.4-.5-4.6-1.4-6.6H6.4z"
          fill="#1bb5ec"
        />
        <path
          d="M7 29.83c.1-1.8.5-3.6 1.2-5.2h15.6c.7 1.6 1.1 3.3 1.2 5.2H7zm9-12.3c2.8.9 5.1 2.7 6.7 5.1H9.3c1.6-2.3 3.9-4.1 6.7-5.1zM7 3.13h18c-.2 5.7-3.7 10.5-9 12.3-5.3-1.8-8.8-6.7-9-12.3zm21 26.7h-1c-.2-5.8-3.4-10.9-8.3-13.4 4.9-2.5 8.1-7.6 8.3-13.4h1c.6 0 1-.5 1-1s-.4-1-1-1H4c-.6 0-1 .5-1 1s.4 1 1 1h1c.2 5.8 3.4 10.9 8.3 13.4-4.9 2.6-8.1 7.7-8.3 13.4H4c-.6 0-1 .5-1 1s.4 1 1 1h24c.6 0 1-.5 1-1s-.4-1-1-1z"
          fill="#364f6b"
        />
      </g>
    </Svg>
    
  );
}
 
 
function SvgTelefono(props) {
  
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 16 16"
      {...props}
    >
      <Defs>
        <Path
          id="a_a"
          d="M3.8 6.5c1.4 0 2.5-1.1 2.5-2.5 0-.6-.2-1.1-.5-1.5h4.5c-.4.4-.6.9-.6 1.5 0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5c0-1.6-1.5-2.5-2.2-2.5h-9c-.7 0-2.2.8-2.2 2.5 0 1.4 1.1 2.5 2.5 2.5M13.7 4c0 2-3 2-3 0 0-.8.7-1.5 1.5-1.5.9 0 1.5.7 1.5 1.5M3.8 2.5c.4 0 .8.2 1.1.4.2.3.4.7.4 1.1 0 2-3 2-3 0 0-.8.6-1.5 1.5-1.5"
        />
      </Defs>
      <ClipPath id="a_b">
        <Use xlinkHref="#a_a" overflow="visible" />
      </ClipPath>
      <G clipPath="url(#a_b)">
        <Defs>
          <Path id="a_c" d="M0 0h16v16H0z" />
        </Defs>
        <ClipPath id="a_d">
          <Use xlinkHref="#a_c" overflow="visible" />
        </ClipPath>
        <Path
          clipPath="url(#a_d)"
          fill="#007db7"
          d="M-3.7-3.5h23.5v15H-3.7z"
        />
      </G>
      <G>
        <Defs>
          <Path
            id="a_e"
            d="M13.6 8.1l-3.3-.9-.9-1.5c-.1-.1-.2-.2-.4-.2H7c-.2 0-.3.1-.4.2l-.9 1.6-3.3.8C1.3 8.4.5 9.4.5 10.5V13c0 .8.7 1.5 1.5 1.5h12c.8 0 1.5-.7 1.5-1.5v-2.5c0-1.1-.8-2.1-1.9-2.4zm.9 4.9c0 .3-.2.5-.5.5H2c-.3 0-.5-.2-.5-.5v-2.5c0-.7.5-1.3 1.1-1.5l3.5-.9c.1 0 .2-.1.3-.2l.9-1.5h1.4L9.6 8c.1.1.2.2.3.2l3.5.9c.7.2 1.1.8 1.1 1.5V13z"
          />
        </Defs>
        <ClipPath id="a_f">
          <Use xlinkHref="#a_e" overflow="visible" />
        </ClipPath>
        <G clipPath="url(#a_f)">
          <Defs>
            <Path id="a_g" d="M0 0h16v16H0z" />
          </Defs>
          <ClipPath id="a_h">
            <Use xlinkHref="#a_g" overflow="visible" />
          </ClipPath>
          <Path
            clipPath="url(#a_h)"
            fill="#007db7"
            d="M-4.5.5h25v19h-25z"
          />
        </G>
      </G>
      <G>
        <Defs>
          <Path
            id="a_i"
            d="M8 8.5c-1.2 0-2.2 1-2.2 2.2S6.8 13 8 13s2.2-1 2.2-2.2-1-2.3-2.2-2.3M8 12c-.7 0-1.2-.6-1.2-1.2S7.3 9.5 8 9.5s1.2.6 1.2 1.2S8.7 12 8 12"
          />
        </Defs>
        <ClipPath id="a_j">
          <Use xlinkHref="#a_i" overflow="visible" />
        </ClipPath>
        <G clipPath="url(#a_j)">
          <Defs>
            <Path id="a_k" d="M0 0h16v16H0z" />
          </Defs>
          <ClipPath id="a_l">
            <Use xlinkHref="#a_k" overflow="visible" />
          </ClipPath>
          <Path
            clipPath="url(#a_l)"
            fill="#007db7"
            d="M.8 3.5h14.5V18H.8z"
          />
        </G>
      </G>
    </Svg>
    
  );
}

 
function SvgTicket(props) {
  
  return (
      
    <Svg id="prefix__n_1" xmlns="http://www.w3.org/2000/svg" x={0} y={0} viewBox="0 0 334 414" xmlSpace="preserve" {...props} >
      <style>
        {".prefix__sn3{fill-rule:evenodd;clip-rule:evenodd;fill:#e4e4e6}"}
      </style>
      <g id="prefix__Artboard-Copy-15">
        <g id="prefix__TICKET" transform="translate(7 7)">
          <g id="prefix__Combined-Shape">
            <path
              id="prefix__path-1"
              d="M320 0v71c-4.4 0-8 3.6-8 8s3.6 8 8 8v313h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8h-8c0-4.4-3.6-8-8-8s-8 3.6-8 8H0V87c4.4 0 8-3.6 8-8s-3.6-8-8-8V0h320z"
              fillRule="evenodd"
              clipRule="evenodd"
            />
            <path
              d="M319.5.5v70c-2.1.1-4.1 1-5.5 2.5-1.5 1.5-2.5 3.7-2.5 6s1 4.5 2.5 6c1.4 1.4 3.4 2.4 5.5 2.5h0v312h-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7c-.1-2.1-1-4.1-2.5-5.5-1.5-1.5-3.7-2.5-6-2.5s-4.5 1-6 2.5c-1.4 1.4-2.4 3.4-2.5 5.5h0-7v-312c2.1-.1 4.1-1 5.5-2.5 1.5-1.5 2.5-3.7 2.5-6s-1-4.5-2.5-6c-1.4-1.4-3.4-2.4-5.5-2.5h0V.5h319z"
              fillRule="evenodd"
              clipRule="evenodd"
              fill="#fff"
              stroke="#e9e9e9"
            />
          </g>
          <path
            id="prefix__Line"
            fill="none"
            stroke="#e9e9e9"
            strokeLinecap="square"
            strokeDasharray={6}
            d="M10 79.5h301.5"
          />
          <g id="prefix__SELLO-MOBILE" transform="translate(108 280)">
            <g id="prefix__SELLO" transform="translate(12 8)">
              <path
                id="prefix__CIRCULO-EXTERNO"
                className="prefix__sn3"
                d="M40 1C18.5 1 1 18.5 1 40s17.5 39 39 39 39-17.5 39-39S61.5 1 40 1m0 79C17.9 80 0 62.1 0 40S17.9 0 40 0s40 17.9 40 40-17.9 40-40 40"
              />
              <path
                id="prefix__CIRCULO-INTERNO"
                className="prefix__sn3"
                d="M40.5 15C26.5 15 15 26.5 15 40.5S26.5 66 40.5 66 66 54.5 66 40.5 54.5 15 40.5 15m0 52C25.9 67 14 55.1 14 40.5S25.9 14 40.5 14 67 25.9 67 40.5 55.1 67 40.5 67"
              />
              <g id="prefix__ISO-COOPEUCH" transform="translate(26 25)">
                <path
                  id="prefix__ISO-2"
                  className="prefix__sn3"
                  d="M28.3 12.7c-8.4.3-15.1 7-15.4 15.3 0 .3.2.6.6.6h12.1c1.9 0 3.4-1.5 3.4-3.4v-12c-.2-.2-.4-.5-.7-.5"
                />
                <path
                  id="prefix__ISO-1"
                  className="prefix__sn3"
                  d="M25.5 0H10.7C4.8 0 0 4.7 0 10.6v14.7c0 1.8 1.5 3.3 3.4 3.3h2c.3 0 .5-.2.6-.5.2-12.2 10.1-22 22.3-22.2.3 0 .5-.2.5-.5v-2c0-1.9-1.5-3.4-3.3-3.4"
                />
              </g>
              <g id="prefix__TEXTO" transform="translate(6 6)">
                <g id="prefix__COOPERATIVA" transform="translate(.218 .25)">
                  <path
                    id="prefix__n20"
                    className="prefix__sn3"
                    d="M4 33.9c0 .6-.2 1.1-.5 1.4-.3.3-.8.5-1.5.5-.3 0-.6 0-.9-.1-.3-.1-.5-.2-.6-.4-.2-.2-.3-.4-.4-.6 0-.3-.1-.5-.1-.8v-.4c0-.1 0-.2.1-.3 0-.1.1-.2.1-.2 0-.1.1-.1.1-.1l.7.1c-.1.1-.1.3-.2.4 0 .2-.1.3-.1.5 0 .1 0 .3.1.4 0 .1.1.2.2.3.1.1.2.2.4.2.2.1.3.1.6.1.2 0 .3 0 .5-.1.2 0 .3-.1.4-.2l.3-.3c.1-.1.1-.3.1-.5v-.3c0-.1 0-.2-.1-.3 0-.1 0-.1-.1-.2l-.1-.1.7-.2c.1.1.1.3.2.5s.1.4.1.7"
                  />
                  <path
                    id="prefix__n22"
                    className="prefix__sn3"
                    d="M2.1 31.4h.5c.1 0 .3-.1.4-.2l.3-.3c.1-.1.1-.3.1-.4v-.4c0-.1-.1-.2-.2-.3-.1-.1-.2-.2-.4-.2-.1-.1-.3-.1-.5-.1h-.5c-.2 0-.3.1-.4.2l-.3.3c-.1.1-.1.1-.1.2v.4c0 .1.1.2.2.3.1.1.2.2.4.2.2.2.3.3.5.3m.3-2.9c.3 0 .6.1.8.2.2.1.4.3.6.5.1.2.3.4.3.6.1.2.1.5 0 .8 0 .3-.1.5-.2.7-.1.2-.3.4-.4.6-.2.2-.4.3-.7.3-.3.1-.6.1-.9.1-.3 0-.6-.1-.8-.2-.2-.1-.4-.3-.6-.5-.2-.2-.3-.4-.3-.6-.1-.2-.1-.5 0-.7 0-.3.1-.5.2-.7.1-.2.3-.4.5-.6.2-.2.4-.3.7-.3.2-.2.5-.3.8-.2"
                  />
                  <path
                    id="prefix__n24"
                    className="prefix__sn3"
                    d="M2.8 27h.5c.2 0 .3 0 .4-.1.2 0 .3-.1.3-.2.1-.1.2-.2.2-.4v-.4c0-.1-.1-.3-.2-.4l-.3-.3c-.1-.1-.2-.2-.4-.2s-.4-.1-.5-.1c-.2 0-.3 0-.4.1-.1.1-.2.1-.3.2-.1.1-.2.2-.2.4v.4c0 .1.1.3.2.4l.3.3c0 .1.2.2.4.3m.7-2.9c.3.1.6.2.8.4.2.2.4.3.5.5.1.2.2.5.2.7 0 .2 0 .5-.1.8-.1.3-.2.5-.3.7-.1.2-.3.4-.5.5-.2.1-.4.2-.7.2-.3 0-.6 0-.9-.1-.3-.1-.6-.2-.8-.4-.2-.2-.4-.3-.5-.6-.1-.1-.2-.3-.2-.6 0-.2 0-.5.1-.7.1-.3.2-.5.3-.7.1-.2.3-.4.5-.5.2-.1.4-.2.7-.2.3-.1.6-.1.9 0"
                  />
                  <path
                    id="prefix__n26"
                    className="prefix__sn3"
                    d="M3.1 21.8c0 .1 0 .1-.1.2v.1l1 .4.1-.3c.1-.3.2-.5.1-.7 0-.2-.1-.3-.3-.4-.1 0-.2-.1-.3 0-.1 0-.2 0-.2.1l-.2.2c0 .2 0 .3-.1.4m-.7-.2c.2-.5.5-.9.8-1.1.3-.2.7-.2 1.1-.1.4.2.7.4.7.8.1.4 0 .8-.2 1.3l-.1.3 1.2.5-.3.7-3.5-1.4c0-.2.1-.4.2-.6 0-.1 0-.3.1-.4"
                  />
                  <path
                    id="prefix__n28"
                    className="prefix__sn3"
                    d="M6.9 20.9l-3.4-1.8 1.3-2.3.6.3-.8 1.5.7.4.7-1.3.6.3-.7 1.3.8.5.9-1.7.6.4z"
                  />
                  <path
                    id="prefix__n30"
                    className="prefix__sn3"
                    d="M6.6 15.3c0 .1-.1.1-.1.1s0 .1-.1.1l.9.6.1-.2c.2-.3.3-.5.3-.6 0-.2-.1-.3-.2-.4-.2-.1-.3-.1-.5-.1-.1.1-.3.3-.4.5m-.7-.4c.3-.5.7-.8 1-.9.3-.1.7-.1 1.1.2.2.2.4.3.4.5.1.2.1.4 0 .7h1.4c.2 0 .3 0 .5.1l-.6.8H8.1l-.2.3 1.1.7-.5.7-3.1-2.1c.1-.2.2-.3.3-.5 0-.2.1-.4.2-.5"
                  />
                  <path
                    id="prefix__n32"
                    className="prefix__sn3"
                    d="M9.5 11.9c0 .1.1.1.1.2s.1.2.2.3c.1.1.1.2.2.4.1.1.2.3.2.4l.7-.8c-.2-.1-.3-.1-.5-.2s-.3-.1-.4-.2h-.3c-.1-.1-.1-.1-.2-.1zm2.9 1.2c-.1-.1-.2-.1-.4-.2-.1-.1-.3-.1-.4-.2l-1 1.1c.1.1.1.3.2.4.1.1.1.3.2.4l-.6.7c-.2-.4-.4-.7-.6-1.1-.2-.3-.3-.6-.5-.9-.1-.3-.3-.6-.4-.9-.1-.3-.2-.5-.4-.8l.6-.6.9.3.9.3c.3.1.6.2 1 .4.3.1.7.3 1.1.5l-.6.6z"
                  />
                  <path
                    id="prefix__n34"
                    className="prefix__sn3"
                    d="M12.6 7.7l.4.6-.8.7 2.1 2.3-.7.6-2.1-2.3-.8.8-.5-.5z"
                  />
                  <path
                    id="prefix__n36"
                    className="prefix__sn3"
                    d="M13.2 7.3l.7-.6 2.3 3.1-.7.5z"
                  />
                  <path
                    id="prefix__n38"
                    className="prefix__sn3"
                    d="M17.8 8.7l-.9-.6-.9-.6c-.3-.2-.6-.4-.8-.6-.3-.2-.5-.4-.7-.5l.8-.5c.2.1.4.3.6.5.2.2.4.3.6.5.2.2.4.3.6.5.2.2.4.3.5.4 0-.2-.1-.4-.1-.6-.1-.2-.1-.5-.2-.8-.1-.3-.1-.5-.2-.8-.1-.3-.1-.5-.2-.7l.8-.5c.1 0 .2.3.3.6.1.3.1.7.2 1 .1.4.1.7.2 1.1.1.4.1.7.2 1.1l-.8.5z"
                  />
                  <path
                    id="prefix__n40"
                    className="prefix__sn3"
                    d="M20 4.1v1.5l1-.5c0-.1-.1-.2-.3-.3l-.3-.3c-.1-.1-.2-.2-.3-.2 0-.1-.1-.2-.1-.2zm2.2 2.2l-.3-.3-.3-.3-1.4.6v.4c0 .1 0 .3.1.4l-.8.4c0-.4-.1-.8-.1-1.2 0-.4-.1-.7-.1-1.1 0-.3 0-.6-.1-1v-.9l.8-.2c.2.2.5.4.7.6.2.2.5.4.7.6.2.2.5.5.8.7.3.3.6.5.9.9l-.9.4z"
                  />
                  <path
                    id="prefix__n42"
                    className="prefix__sn3"
                    d="M25.3 4.5H25.6c.4-.1.7-.3.8-.6.1-.3.2-.6.1-.9-.1-.4-.3-.7-.5-.8-.2-.1-.6-.2-1 0-.1 0-.1 0-.2.1-.1 0-.1 0-.2.1l.7 2.1zm2.1-1.9c.1.3.1.6.1.9 0 .3-.1.5-.3.7-.1.2-.3.4-.6.5-.2.2-.5.3-.9.4-.2 0-.3.1-.5.1s-.4.1-.6.1l-1-3.6c.2-.1.4-.2.6-.2.2-.1.4-.1.5-.2.3-.1.6-.1.9-.1.3 0 .5 0 .8.1.2.1.4.3.6.5.1.2.3.5.4.8z"
                  />
                  <path
                    id="prefix__n44"
                    className="prefix__sn3"
                    d="M28.5 4.4L27.9.6l2.6-.4.1.7-1.7.3.1.7 1.5-.2.1.7-1.5.2.1.9 1.9-.3.1.8z"
                  />
                  <path
                    id="prefix__n46"
                    className="prefix__sn3"
                    d="M34.6.9c0 .1 0 .1-.1.2 0 .1-.1.2-.1.3 0 .1-.1.3-.2.4 0 .2-.1.3-.2.5h1.1c0-.1-.1-.3-.1-.5-.1-.2-.1-.3-.2-.4s-.1-.2-.1-.3c0-.1-.1-.2-.1-.2zm1 2.9c0-.1-.1-.3-.1-.4 0-.1-.1-.3-.1-.4h-1.5c-.1.1-.1.3-.2.4-.1.1-.1.3-.1.4h-.9c.2-.4.3-.8.4-1.1.1-.3.3-.7.4-1 .1-.3.3-.6.4-.9.1-.3.2-.5.3-.8h.8c.1.3.2.5.4.8.1.3.2.6.4.9.1.3.2.6.4 1 .1.4.3.7.4 1.1h-1z"
                  />
                  <path
                    id="prefix__n48"
                    className="prefix__sn3"
                    d="M39.7.4l.9.1-.5 3.8-.9-.1.2-1.6-1.4-.2-.2 1.6-.9-.1.5-3.8.9.1-.2 1.5 1.4.2z"
                  />
                  <path
                    id="prefix__n50"
                    className="prefix__sn3"
                    d="M42 2.8v.5c0 .2 0 .3.1.4.1.1.1.2.2.3.1.1.2.2.4.2s.3.1.4 0c.1 0 .3-.1.4-.2l.3-.3c.1-.1.2-.2.2-.4.1-.2.1-.4.1-.5 0-.2 0-.3-.1-.4-.1-.1-.1-.2-.2-.3-.1-.1-.2-.2-.4-.2s-.3-.1-.4 0c-.1 0-.3.1-.4.2l-.3.3c-.1.1-.2.2-.3.4m2.9.8c-.1.3-.2.6-.4.8-.2.2-.3.4-.6.5-.2.1-.4.1-.6.2-.3 0-.5 0-.8-.1-.3-.1-.5-.2-.7-.3-.2-.1-.4-.3-.5-.5-.1-.2-.2-.4-.2-.7 0-.3 0-.6.1-.9.1-.3.2-.6.4-.8.2-.2.4-.4.6-.5.2-.1.4-.2.7-.2.2 0 .5 0 .7.1.3.1.5.2.7.3.2.1.4.3.5.5.1.2.2.4.2.7s0 .6-.1.9"
                  />
                  <path
                    id="prefix__n52"
                    className="prefix__sn3"
                    d="M47.2 3.2c-.1 0-.1 0-.2-.1h-.1l-.4 1 .2.1c.3.1.5.2.7.2.2 0 .3-.1.4-.3.1-.2.1-.3 0-.5s-.3-.3-.6-.4m.3-.7c.5.2.9.5 1.1.8s.2.7.1 1.1c-.1.2-.2.4-.4.5-.3.1-.5.2-.7.1 0 .1.1.3.1.4 0 .1.1.3.1.5s0 .3.1.5v.5l-.9-.4v-.4c0-.1 0-.3-.1-.4 0-.1 0-.3-.1-.4 0-.1-.1-.2-.1-.4l-.4-.2-.6 1.3-.8-.3 1.5-3.5c.2 0 .4.1.6.2.2 0 .3.1.5.1"
                  />
                  <path
                    id="prefix__n54"
                    className="prefix__sn3"
                    d="M50.8 4.9c-.1 0-.1-.1-.2-.1 0 0-.1 0-.1-.1l-.5 1 .2.1c.3.2.5.2.7.2.2 0 .3-.1.4-.3.1-.2.1-.3 0-.5-.1 0-.3-.1-.5-.3m.3-.6c.5.3.8.6 1 .9.2.3.1.7-.1 1.1-.1.2-.3.4-.5.5-.2.1-.4.1-.7.1v1.9l-.8-.5v-.4-.4-.4-.4l-.4-.2-.6 1-.8-.4 1.9-3.3c.2.1.4.1.5.2.2.1.4.2.5.3"
                  />
                  <path
                    id="prefix__n56"
                    className="prefix__sn3"
                    d="M53 7.7c-.1.1-.2.3-.3.4-.1.1-.1.3-.1.4 0 .1 0 .3.1.4l.3.3c.1.1.3.2.4.2h.4c.1 0 .3-.1.4-.2.1-.1.3-.2.4-.4.1-.1.2-.3.3-.4 0-.1.1-.2.1-.4 0-.1 0-.3-.1-.4l-.3-.3c-.1-.1-.3-.2-.4-.2h-.4c-.1 0-.3.1-.4.2-.2.1-.3.3-.4.4m2.4 1.8c-.2.3-.4.5-.6.6-.2.1-.5.2-.7.3-.2 0-.5 0-.7-.1-.2-.1-.5-.2-.7-.4-.2-.2-.4-.3-.5-.5-.1-.2-.2-.4-.3-.7V8c.1-.3.2-.5.4-.8s.4-.5.6-.6c.2-.1.5-.2.7-.3.2 0 .5 0 .7.1.2.1.5.2.7.3.2.2.4.3.5.5.1.2.2.4.3.7 0 .2 0 .5-.1.7 0 .3-.2.6-.3.9"
                  />
                  <path
                    id="prefix__n58"
                    className="prefix__sn3"
                    d="M58.2 11.7c.3-.1.6-.1.9-.2.3-.1.6-.2.8-.3l.7.7c-.4.1-.9.2-1.3.3-.4.1-.9.2-1.3.3l-1.1 1-.7-.5 1.1-1c.1-.4.2-.9.4-1.3.1-.4.3-.9.4-1.3l.7.7c-.1.3-.2.5-.3.8-.1.3-.2.6-.3.8"
                  />
                  <path
                    id="prefix__n60"
                    className="prefix__sn3"
                    d="M59.7 17.4c-.4-.5-.5-1-.4-1.5.1-.5.4-.9 1-1.2.3-.2.5-.3.8-.4.3-.1.5-.1.8 0 .2 0 .5.1.7.3.2.1.4.3.6.6.1.1.2.3.2.4.1.1.1.2.1.3 0 .1.1.2.1.3v.2l-.7.2c0-.1 0-.3-.1-.4-.1-.2-.1-.3-.2-.5l-.3-.3c-.1-.1-.2-.1-.4-.2h-.4c-.2 0-.3.1-.5.2-.1.1-.3.2-.4.3-.1.1-.2.2-.2.4 0 .1-.1.3 0 .4 0 .2.1.3.2.5.1.1.1.2.2.3l.2.2c.1.1.1.1.2.1s.1.1.2.1l-.4.6c-.1-.1-.3-.2-.5-.3-.5-.2-.6-.4-.8-.6"
                  />
                  <path
                    id="prefix__n62"
                    className="prefix__sn3"
                    d="M64.1 18.4c0-.1-.1-.1-.1-.1l-.1-.1-.9.4.1.2c.2.3.3.5.4.6.1.1.3.1.5 0s.3-.2.3-.4-.1-.4-.2-.6m.6-.4c.3.5.4.9.3 1.3 0 .4-.3.6-.6.8-.2.1-.5.2-.7.1-.2 0-.4-.1-.6-.3-.1.1-.1.2-.2.4-.1.1-.1.3-.2.4-.1.1-.2.3-.3.4-.1.1-.2.3-.3.4l-.5-.9c.1-.1.2-.2.2-.4.1-.1.2-.2.2-.4.1-.1.1-.2.2-.4.1-.1.1-.2.2-.3l-.2-.4-1.2.6-.4-.8 3.4-1.7c.1.1.2.3.3.5.2.4.3.5.4.7"
                  />
                  <path
                    id="prefix__n64"
                    className="prefix__sn3"
                    d="M67.6 22.1l-1.1-.6.2-.5 1.1.4-.2.7zm-5.3-.1l3.6-1.4.9 2.4-.7.3-.6-1.6-.7.3.6 1.4-.7.3-.6-1.4-.9.3.7 1.7-.7.3-.9-2.6z"
                  />
                  <path
                    id="prefix__n66"
                    className="prefix__sn3"
                    d="M64.4 25.6V25.9c.1.4.3.7.6.8s.6.2 1 .1.7-.3.8-.5c.2-.2.2-.6.1-1v-.2c0-.1 0-.1-.1-.2l-2.4.7zm1.8 2.2c-.3.1-.6.1-.9.1s-.5-.1-.7-.3c-.2-.1-.4-.3-.5-.6-.1-.2-.3-.5-.3-.9 0-.1-.1-.3-.1-.5s-.1-.4-.1-.6l3.6-.9c.1.2.2.4.2.6.1.2.1.4.2.5.1.3.1.6.1.9 0 .3-.1.5-.2.8-.1.2-.3.4-.5.6-.2 0-.5.2-.8.3z"
                  />
                  <path
                    id="prefix__n68"
                    className="prefix__sn3"
                    d="M68.2 28.3l.1.8-3.8.6-.1-.9z"
                  />
                  <path
                    id="prefix__n70"
                    className="prefix__sn3"
                    d="M68.7 33l-.7.1-.1-1.2-3.1.3-.1-.9 3.1-.2-.1-1.2h.8z"
                  />
                  <path
                    id="prefix__n72"
                    className="prefix__sn3"
                    d="M66.8 34.4h-.5c-.2 0-.3.1-.4.2l-.3.3c-.1.1-.1.3-.1.4 0 .2 0 .3.1.4.1.1.1.2.2.3.1.1.2.2.4.2.2.1.3.1.5.1h.5c.2 0 .3-.1.4-.2l.3-.3c.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4-.1-.1-.1-.2-.2-.3-.1-.1-.2-.2-.4-.2s-.3 0-.5-.1m-.2 3c-.3 0-.6-.1-.9-.2-.2-.1-.4-.3-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.8 0-.3.1-.5.2-.7.1-.2.2-.4.4-.6.2-.2.4-.3.6-.4.3-.1.5-.1.9-.1.3 0 .6.1.9.2.2.1.4.3.6.4.2.2.3.4.4.6.1.2.1.5.1.7 0 .3-.1.5-.2.7-.1.2-.2.4-.4.6-.2.2-.4.3-.7.4-.1.1-.4.2-.8.2"
                  />
                </g>
                <g
                  id="prefix___x31_00_x25_-SEGURO"
                  transform="rotate(3 -1126.391 332.913)"
                >
                  <path
                    id="prefix__n74"
                    className="prefix__sn3"
                    d="M.6.8H1.8c.1 0 .2 0 .4-.1l.4.3L.7 4.4 0 4l1.4-2.5H.6V.8z"
                  />
                  <path
                    id="prefix__n76"
                    className="prefix__sn3"
                    d="M4.4 3.9c.1-.2.1-.3.2-.5 0-.2.1-.3.1-.4v-.3c0-.1-.1-.1-.2-.2h-.3c-.1 0-.2.1-.3.2l-.3.3c0 .2-.1.3-.2.5s-.1.4-.2.5c0 .2-.1.3-.1.4v.3c0 .1.1.1.2.2h.3c.1 0 .2-.1.3-.2.1 0 .1-.2.2-.3.1-.1.2-.3.3-.5m.7.4c-.3.6-.6 1-.9 1.2-.4.2-.8.3-1.1.1-.4-.2-.7-.5-.7-.9-.1-.4 0-.9.3-1.5.1-.3.3-.6.4-.8.1-.2.3-.3.5-.4.2-.2.4-.2.5-.2.2 0 .4 0 .6.1.4.1.6.4.7.8.1.4 0 1-.3 1.6"
                  />
                  <path
                    id="prefix__n78"
                    className="prefix__sn3"
                    d="M7.3 5c.1-.2.1-.4.1-.5v-.4c0-.1 0-.2-.1-.3 0-.1-.1-.1-.2-.2h-.3c-.1 0-.2.1-.2.2s-.1.2-.1.3c-.1.2-.2.4-.2.5-.1.2-.1.4-.2.6v.4c0 .1 0 .2.1.3 0 .1.1.1.1.2h.3c.1 0 .2-.1.2-.2.1-.2.2-.3.3-.4 0-.2.1-.3.2-.5m.7.2c-.2.6-.4 1.1-.8 1.3-.3.3-.7.4-1.1.2-.4-.1-.6-.4-.7-.8-.2-.4-.1-.9.1-1.5.1-.3.2-.6.4-.8.1-.2.2-.4.4-.5.2-.1.4-.2.5-.3h.6c.4.2.7.5.8.9.1.4 0 .9-.2 1.5"
                  />
                  <path
                    id="prefix__n80"
                    className="prefix__sn3"
                    d="M12.1 7.1v-.4c0-.1-.1-.2-.2-.2s-.2 0-.3.1c-.1.1-.1.2-.2.4v.4c0 .1.1.2.2.2s.2 0 .3-.1c.1-.1.2-.2.2-.4zm.6.1c-.1.3-.2.6-.4.7-.2.2-.4.2-.7.1-.3-.1-.5-.2-.6-.4-.1-.2-.2-.5-.1-.8.1-.3.2-.6.4-.7s.4-.2.7-.1c.3.1.5.2.6.4.1.2.2.4.1.8zM9.9 4.7v-.4c0-.1-.1-.2-.2-.2s-.2 0-.3.1c-.1.1-.1.2-.2.4V5c0 .1.1.2.2.2s.2 0 .3-.1c.1-.1.2-.2.2-.4zm1.8-.7l.7.1-2.8 3.5-.7-.1L11.7 4zm-1.2.8c-.1.3-.2.6-.4.7-.2.2-.5.3-.8.2-.2 0-.4-.2-.6-.4-.1-.2-.1-.5-.1-.8.1-.4.2-.6.4-.8.2-.2.4-.2.7-.1.3.1.5.2.6.4.2.2.3.5.2.8z"
                  />
                  <path
                    id="prefix__n82"
                    className="prefix__sn3"
                    d="M15.9 7.7h.3c.1 0 .1 0 .2-.1l.1-.1v-.2c0-.1 0-.2-.2-.3-.1-.1-.3-.2-.6-.3-.1 0-.2-.1-.4-.2-.1-.1-.2-.1-.3-.2 0-.1-.1-.2-.2-.3-.1-.1-.1-.3-.1-.5s0-.3.1-.5c.1-.1.2-.3.3-.4.1-.1.3-.2.4-.2.2 0 .4-.1.6-.1.2 0 .5 0 .6.1.2.1.3.1.4.2l-.1.8c-.1-.1-.2-.1-.3-.2-.1 0-.3-.1-.5-.1s-.3 0-.4.1c-.1.1-.1.1-.1.3v.2l.1.1c.1 0 .1.1.2.1s.2.1.3.1c.2.1.4.2.5.2.1.1.3.2.3.3.1.1.2.2.2.3 0 .1.1.3.1.5 0 .4-.1.6-.4.8-.2.2-.6.3-1.1.3h-.4c-.1 0-.2-.1-.3-.1-.1 0-.2-.1-.3-.1-.1 0-.1-.1-.2-.1l.3-.7c.1.1.2.1.4.2 0 .1.2.1.5.1"
                  />
                  <path
                    id="prefix__n84"
                    className="prefix__sn3"
                    d="M18.2 8.4l-.3-3.9 2.5-.2.1.8-1.7.1.1.7 1.5-.1v.7l-1.5.1.1 1 1.8-.1v.7z"
                  />
                  <path
                    id="prefix__n86"
                    className="prefix__sn3"
                    d="M22.9 4.6c-.4.1-.6.2-.8.5-.1.2-.1.6 0 .9 0 .2.1.4.2.5.1.1.2.3.3.4.1.1.2.2.4.2h.7c.1 0 .1 0 .2-.1l-.2-1.3.8-.1.3 1.9c-.1.1-.2.1-.5.2-.2.1-.5.2-.8.2h-.8c-.2 0-.5-.1-.6-.3-.2-.1-.3-.3-.5-.6-.1-.2-.2-.5-.3-.8-.1-.3-.1-.6 0-.9 0-.3.1-.5.3-.7.1-.2.3-.4.5-.5.2-.1.4-.2.7-.3h.9c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.7c-.1 0-.3-.1-.4-.1h-.8"
                  />
                  <path
                    id="prefix__n88"
                    className="prefix__sn3"
                    d="M27.1 7c-.3.1-.5.1-.7.1-.2-.1-.4-.1-.5-.2-.2-.1-.3-.2-.4-.4l-.3-.6-.7-2.3.8-.2.7 2.2c0 .2.1.3.2.4.1.1.1.2.2.2s.2.1.2.1h.3c.2-.1.3-.2.4-.3.1-.2.1-.4 0-.7L26.6 3l.8-.2.7 2.2c.1.2.1.4.1.6 0 .2 0 .4-.1.6-.1.2-.2.3-.4.4-.1.2-.3.3-.6.4"
                  />
                  <path
                    id="prefix__n90"
                    className="prefix__sn3"
                    d="M29.3 2.7c-.1 0-.1 0-.1.1 0 0-.1 0-.1.1l.4 1 .2-.1c.3-.1.5-.2.6-.4.1-.1.1-.3 0-.5s-.2-.3-.4-.3c-.1-.1-.3 0-.6.1M29 2c.5-.2.9-.3 1.3-.2.4.1.6.3.8.7.1.3.1.5.1.7 0 .2-.1.4-.3.6.1 0 .2.1.3.2.1.1.3.2.4.3.1.1.3.2.4.3.1.1.3.2.4.3l-.9.4-.3-.3c-.1-.1-.2-.2-.4-.3-.1-.1-.2-.2-.3-.2-.1-.1-.2-.1-.3-.2l-.4.2.6 1.3-.8.3L28 2.5c.2-.1.3-.2.5-.3.2 0 .4-.1.5-.2"
                  />
                  <path
                    id="prefix__n92"
                    className="prefix__sn3"
                    d="M32.6 2.5c.1.2.2.3.3.4.1.1.2.2.4.2s.3.1.4.1c.1 0 .3-.1.4-.1.1-.1.3-.1.3-.3.1-.1.1-.2.1-.4V2c0-.2-.1-.3-.2-.5s-.2-.3-.3-.4c-.1-.1-.2-.2-.4-.3-.1-.1-.3-.1-.4-.1-.1 0-.3.1-.4.1l-.3.3c-.1.1-.1.2-.1.4v.4c.1.3.1.5.2.6m2.5-1.4c.2.3.3.6.3.8v.7l-.3.6c-.2.2-.3.3-.6.5-.2.2-.4.3-.7.3h-.7c-.2-.1-.5-.2-.7-.4-.2-.2-.4-.4-.6-.7-.2-.3-.3-.6-.3-.8v-.8l.3-.6c.1-.2.3-.3.5-.5.2-.1.4-.2.7-.2h.7c.2.1.5.2.7.4.3.2.5.4.7.7"
                  />
                </g>
              </g>
            </g>
            <g id="prefix__EXITO" transform="translate(76 60)">
              <path
                id="prefix__FONDO-BLANCO"
                d="M8 .5C3.8.5.5 3.8.5 8s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5C15.5 3.8 12.2.5 8 .5"
                fillRule="evenodd"
                clipRule="evenodd"
                fill="#fff"
              />
              <g id="prefix___x30_0_Token_x2F_Icons_x2F_Solid_x2F_32x32_x2F_check">
                <path
                  id="prefix__color-icono"
                  d="M8 .5C3.8.5.5 3.8.5 8s3.4 7.5 7.5 7.5 7.5-3.4 7.5-7.5C15.5 3.8 12.2.5 8 .5m2.4 5c.3-.3.8-.4 1.1-.1.3.3.4.7.1 1l-.1.1-4.3 5-2.7-2.8c-.3-.3-.3-.8 0-1.1.3-.3.7-.3 1.1-.1l.1.1 1.5 1.5 3.2-3.6z"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  fill="#787880"
                  fillOpacity={0.2}
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </Svg>
    
  );
}


function SvgTicketBlanco(props) {
  
  return (
      
    <Svg id="h_1" xmlns="http://www.w3.org/2000/svg" x={0} y={0} viewBox="0 0 20 21" xmlSpace="preserve" {...props} >
      <style>
        {".prefix__h1{fill-rule:evenodd;clip-rule:evenodd;fill:#fff}"}
      </style>
      <g id="h__Artboard-Copy-25">
        <g id="h__receipt">
          <g id="h__Page-1">
            <path id="h1" fill="none" d="M0 20h20V0H0z" />
            <g id="h__Group-8" transform="translate(.625 .625)">
              <path
                id="h4"
                className="prefix__h1"
                d="M17.5 17l-3.4-2c-.2-.1-.4-.1-.6 0l-4.1 2.3L5.3 15c-.2-.1-.4-.1-.6 0l-3.4 2V1.3h16.2V17zM.6 0C.3 0 0 .3 0 .6v17.5c0 .5.5.8.9.5L5 16.3l4.1 2.3c.2.1.4.1.6 0l4.1-2.3 4.1 2.3c.4.2.9-.1.9-.5V.6c0-.3-.3-.6-.6-.6H.6z"
              />
              <path
                id="h6"
                className="prefix__h1"
                d="M5 4.4h8.8c.3 0 .6-.3.6-.6s-.3-.6-.6-.6H5c-.3 0-.6.3-.6.6s.3.6.6.6"
              />
            </g>
            <text
              transform="translate(6.875 14)"
              fontSize={10}
              fontFamily="Ubuntu-Bold"
              fill="#fff"
            >
              {"1"}
            </text>
          </g>
        </g>
      </g>
    </Svg>
    
  );
}


function SvgVerListaMapa(props) {
  
  return (
      
    <Svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 28 32" {...props} >
      <defs>
        <path
          id="c1"
          d="M14.1 5c.6 0 1-.4 1-1V2c0-.6-.4-1-1-1s-1 .4-1 1v2c0 .6.4 1 1 1"
        />
      </defs>
      <clipPath id="c2">
        <use xlinkHref="#c1" overflow="visible" />
      </clipPath>
      <g clipPath="url(#c2)">
        <defs>
          <path id="c3" d="M.1 0h28v32H.1z" />
        </defs>
        <clipPath id="c4">
          <use xlinkHref="#c3" overflow="visible" />
        </clipPath>
        <path clipPath="url(#c4)" fill="#f42534" d="M8.1-4h12v14h-12z" />
      </g>
      <defs>
        <path
          id="c5"
          d="M18.3 6.2l1.4-1.4c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0l-1.4 1.4c-.4.4-.4 1 0 1.4.4.4 1 .4 1.4 0"
        />
      </defs>
      <clipPath id="c6">
        <use xlinkHref="#c5" overflow="visible" />
      </clipPath>
      <g clipPath="url(#c6)">
        <defs>
          <path id="c7" d="M.1 0h28v32H.1z" />
        </defs>
        <clipPath id="c8">
          <use xlinkHref="#c7" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#c8)"
          fill="#f42534"
          d="M11.6-2H25v13.4H11.6z"
        />
      </g>
      <g>
        <defs>
          <path
            id="c9"
            d="M18.1 9c0 .6.4 1 1 1h2c.6 0 1-.4 1-1s-.4-1-1-1h-2c-.6 0-1 .4-1 1"
          />
        </defs>
        <clipPath id="c10">
          <use xlinkHref="#c9" overflow="visible" />
        </clipPath>
        <g clipPath="url(#c10)">
          <defs>
            <path id="c11" d="M.1 0h28v32H.1z" />
          </defs>
          <clipPath id="c12">
            <use xlinkHref="#c11" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#c12)"
            fill="#f42534"
            d="M13.1 3h14v12h-14z"
          />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="c13"
            d="M7.1 10h2c.6 0 1-.4 1-1s-.4-1-1-1h-2c-.6 0-1 .4-1 1s.4 1 1 1"
          />
        </defs>
        <clipPath id="c14">
          <use xlinkHref="#c13" overflow="visible" />
        </clipPath>
        <g clipPath="url(#c14)">
          <defs>
            <path id="c15" d="M.1 0h28v32H.1z" />
          </defs>
          <clipPath id="c16">
            <use xlinkHref="#c15" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#c16)"
            fill="#f42534"
            d="M1.1 3h14v12h-14z"
          />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="c17"
            d="M9.8 6.2c.4.4 1 .4 1.4 0s.4-1 0-1.4L9.8 3.3c-.4-.3-1-.3-1.4 0-.4.4-.4 1.1 0 1.5l1.4 1.4z"
          />
        </defs>
        <clipPath id="c18">
          <use xlinkHref="#c17" overflow="visible" />
        </clipPath>
        <g clipPath="url(#c18)">
          <defs>
            <path id="c19" d="M.1 0h28v32H.1z" />
          </defs>
          <clipPath id="c20">
            <use xlinkHref="#c19" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#c20)"
            fill="#f42534"
            d="M3.1-2h13.4v13.4H3.1z"
          />
        </g>
      </g>
      <g>
        <defs>
          <path
            id="c21"
            d="M27 24.4l-.7-4.1c-.2-1.3-1.3-2.3-2.6-2.5l-6.6-.7V11c0-1.7-1.3-3-3-3s-3 1.3-3 3v7.4l-.1-.2c-.9-1.4-2.7-1.8-4.1-.9-1.2.8-1.6 2.3-1.1 3.6l2.4 5.5c0 .1.1.1.1.2l3 4c.3.4 1 .5 1.4.2.4-.3.5-1 .2-1.4L10 25.5l-2.3-5.4c-.2-.4 0-.9.3-1.1.4-.3 1-.2 1.3.3l2 3.3c.2.4.7.6 1.1.4.4-.1.7-.5.7-1V11c0-.6.4-1 1-1s1 .4 1 1v7c0 .5.4.9.9 1l7.5.8c.4 0 .8.4.9.8l.7 4.1c0 .2.1.5.1.7 0 .8-.2 1.6-.7 2.3l-1.1 1.7c-.3.5-.2 1.1.3 1.4.5.3 1.1.2 1.4-.3l1.1-1.7c.7-1 1-2.2 1-3.4-.1-.3-.2-.7-.2-1"
          />
        </defs>
        <clipPath id="c22">
          <use xlinkHref="#c21" overflow="visible" />
        </clipPath>
        <g clipPath="url(#c22)">
          <defs>
            <path id="c23" d="M.1 0h28v32H.1z" />
          </defs>
          <clipPath id="c24">
            <use xlinkHref="#c23" overflow="visible" />
          </clipPath>
          <path clipPath="url(#c24)" fill="#f42534" d="M.5 3H32v33H.5z" />
        </g>
      </g>
    </Svg>
    
  );
}

export {SvgCaja, SvgCalendarioAzul, SvgCalendarioBlanco, SvgDia, 
        SvgDistancia, SvgFila, SvgHora, SvgLista, SvgLogoCoopeuch, 
        SvgLogoCoopeuchMobile, SvgMapaBlue, SvgMapaRojo, SvgPersonas, 
        SvgReloj, SvgRelojArena, SvgTelefono, SvgTicket, SvgTicketBlanco, SvgVerListaMapa}